import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment/locale/th';

import { useTranslation } from 'react-i18next';

// material-ui
import MaterialTable from 'material-table';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';

// component
import tableIcons from '../../../components/table/MaterialTableIcon';
import WaterQualityStatusColor from '../../waterQuality/map/WaterQualityStatusColor';

// style
import { styles } from '../style';
import Contrast from '../../../utils/color/contrast';

// Utils
import exportCsv from '../../../utils/export/Csv';

const useStyles = makeStyles(styles);
export default function WaterQualityDetailList(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { datas, userIsLogin } = props;
  const isExport = (userIsLogin) ? { csv: true } : userIsLogin;

  function waterQualityStatusBadge(data, value, type) {
    if (type === 'ph') {
      const status = WaterQualityStatusColor(data, 'ph');
      const statusText = `
      <p
        className="${classes.status}"
        style=background:${status.color.statusColor};text-align:center;width:60px;margin-left:44%;color:${Contrast(status.color.statusColor)};
      >
      ${Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      </p>`;
      return typeof value === 'undefined' || value == null ? '-' : statusText;
    }
    if (type === 'salinity') {
      const status = WaterQualityStatusColor(data, 'salinity');
      const statusText = `
      <p
        className="${classes.status}"
        style=background:${status.color.statusColor};text-align:center;width:60px;margin-left:44%;color:${Contrast(status.color.statusColor)};
      >
      ${Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      </p>`;
      return typeof value === 'undefined' || value == null ? '-' : statusText;
    }
    if (type === 'turbid') {
      const status = WaterQualityStatusColor(data, 'turbid');
      const statusText = `
      <p
        className="${classes.status}"
        style=background:${status.color.statusColor};text-align:center;width:60px;margin-left:44%;color:${Contrast(status.color.statusColor)};
      >
      ${Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      </p>`;
      return typeof value === 'undefined' || value == null ? '-' : statusText;
    }
    if (type === 'tds') {
      const status = WaterQualityStatusColor(data, 'tds');
      const statusText = `
      <p
        className="${classes.status}"
        style=background:${status.color.statusColor};text-align:center;width:60px;margin-left:44%;color:${Contrast(status.color.statusColor)};
      >
      ${Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      </p>`;
      return typeof value === 'undefined' || value == null ? '-' : statusText;
    }
    if (type === 'do') {
      const status = WaterQualityStatusColor(data, 'do');
      const statusText = `
      <p
        className="${classes.status}"
        style=background:${status.color.statusColor};text-align:center;width:60px;margin-left:44%;color:${Contrast(status.color.statusColor)};
      >
      ${Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      </p>`;
      return typeof value === 'undefined' || value == null ? '-' : statusText;
    }
    return true;
  }

  return (
    <>
      <MaterialTable
        icons={tableIcons}
        data={[...datas.yellow, ...datas.red, ...datas.darkRed]}
        columns={[
          {
            title: t('ชื่อสถานี'),
            title_export: t('ชื่อสถานี'),
            field: 'name',
            width: 230,
            headerStyle: {
              left: 0,
              position: 'sticky',
              zIndex: 50,
              backgroundColor: '#CCCCCC',
            },
            cellStyle: {
              backgroundColor: '#fff',
              left: 0,
              position: 'sticky',
              wordWrap: 'normal',
              textAlign: 'left',
            },
          },
          {
            title: t('ที่ตั้ง'),
            field: 'address',
            type: 'string',
            export: false,
            width: 350,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (rowData) => (rowData.tumbon_name !== '' ? `ต.${rowData.tumbon_name} อ.${rowData.amphoe_name} จ.${rowData.province_name}` : `อ.${rowData.amphoe_name} จ.${rowData.province_name}`),
          },
          {
            title: t('แม่น้ำ'),
            title_export: t('แม่น้ำ'),
            field: 'river_name',
            type: 'string',
            width: 150,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            // hidden: !userIsLogin,
            render: (rowData) => rowData.river_name,
          },
          {
            title: t('เวลา'),
            title_export: t('เวลา'),
            field: 'datetime',
            type: 'date',
            width: 115,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (rowData) => `${moment(rowData.datetime).locale('th').format('LT')} น.`,
          },
          {
            title: t('กรดด่าง'),
            title_export: t('กรดด่าง'),
            field: 'waterquality_ph',
            type: 'numeric',
            sorting: true,
            width: 115,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (rowData) => {
              const WqPh = waterQualityStatusBadge(
                rowData.waterquality_ph,
                rowData.waterquality_ph,
                'ph',
              );
              return <Box style={{ padding: 0 }} dangerouslySetInnerHTML={{ __html: WqPh }} />;
            },
          },
          {
            title: t('ความเค็ม'),
            title_export: t('ความเค็ม'),
            field: 'waterquality_salinity',
            type: 'numeric',
            sorting: true,
            width: 115,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (rowData) => {
              const WqSalinity = waterQualityStatusBadge(
                rowData.waterquality_salinity,
                rowData.waterquality_salinity,
                'salinity',
              );
              return (
                <Box style={{ padding: 0 }} dangerouslySetInnerHTML={{ __html: WqSalinity }} />
              );
            },
          },
          {
            title: t('ความขุ่น'),
            title_export: t('ความขุ่น'),
            field: 'waterquality_turbid',
            type: 'numeric',
            sorting: true,
            width: 115,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (rowData) => {
              const WqTurbid = waterQualityStatusBadge(
                rowData.waterquality_turbid,
                rowData.waterquality_turbid,
                'turbid',
              );
              return (
                <Box style={{ padding: 0 }} dangerouslySetInnerHTML={{ __html: WqTurbid }} />
              );
            },
          },
          {
            title: t('สารละลาย'),
            title_export: t('สารละลาย'),
            field: 'waterquality_tds',
            type: 'numeric',
            sorting: true,
            width: 115,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (rowData) => {
              const WqTds = waterQualityStatusBadge(
                rowData.waterquality_tds,
                rowData.waterquality_tds,
                'tds',
              );
              return (
                <Box style={{ padding: 0 }} dangerouslySetInnerHTML={{ __html: WqTds }} />
              );
            },
          },
          {
            title: t('ออกซิเจน'),
            title_export: t('ออกซิเจน'),
            field: 'waterquality_do',
            type: 'numeric',
            sorting: true,
            width: 115,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (rowData) => {
              const WqDo = waterQualityStatusBadge(
                rowData.waterquality_do,
                rowData.waterquality_do,
                'do',
              );
              return (
                <Box style={{ padding: 0 }} dangerouslySetInnerHTML={{ __html: WqDo }} />
              );
            },
          },
        ]}
        localization={{
          toolbar: {
            searchPlaceholder: t('ค้นหา'),
            exportTitle: t('ดาวน์โหลดข้อมูล คุณภาพน้ำ'),
          },
          pagination: {
            labelRowsSelect: t('แถว'),
          },
          body: { emptyDataSourceMessage: <h3>{t('ไม่มีข้อมูลตามเงื่อนไข')}</h3> },
        }}
        options={{
          tableLayout: 'fixed',
          pageSize: 5,
          sorting: true,
          search: false,
          rowStyle: {
            wordWrap: 'break-word',
          },
          toolbar: true,
          showTitle: false,
          exportButton: isExport,
          exportCsv,
        }}
        style={{ boxShadow: 'none' }}
      />
    </>
  );
}

WaterQualityDetailList.propTypes = {
  datas: PropTypes.instanceOf(Array).isRequired,
  userIsLogin: PropTypes.bool.isRequired,
};
